<template>
  <div @contextmenu="handleContextmenu"
       @touchstart="touchstarts()"
       @touchmove="touchmoves()"
       @touchend="touchends()">
    <!--正常内容 开始-->
    <div>
      <!-- 区块标题 -->
      <tit :title="blockData.title"
           :src='rightSrc'
           @clear="clearSrc"
           :subtitle="blockData.subtitle"
           @refesh="refeshData"
           @backFn="changeFlowTab"></tit>
      <div class="outreach_content">
        <div class="block-content clearfix">
          <!-- 手机端显示按钮 -->
          <div class="btn-left"
               v-show="(floorTabShow.indexOf('left')>-1)"></div>
          <div class="btn-right"
               v-show="(floorTabShow.indexOf('right')>-1)"></div>
          <div class="close-left"
               v-show="isPC?'true':showLeftMenu"></div>
          <div class="close-right"
               v-show="isPC?'true':showRightMenu"></div>
          <!--左侧切换开始-->
          <left-tab v-show="isPC?'true':showLeftMenu"
                    v-if="floorTabShow&&(floorTabShow.indexOf('left')>-1)"
                    :Ind="leftTabInd"
                    :tabActiveType="tabActiveType"
                    :perNum="tabTopBottomLen"
                    :refeshflag="refeshflag"
                    :tempNav="preTabListLeft"
                    :nav="nodeNavLeft"
                    :blockData="blockData"
                    :navHeight="427"
                    @changePerson="changePerson"
                    @changeTab="changeFlowTab" />
          <!--右侧内容区开始-->
          <div class="right-content fl"
               ref='rightContent'
               :style="{width:`calc(100% - ${186*tabLeftRightLen+1}px)`}">
            <!--右侧切换一开始-->
            <div class="content-center">
              <!--顶部切换开始-->
              <top-tab v-if="floorTabShow&&(floorTabShow.indexOf('up')>-1)"
                       :tabActiveType="tabActiveType"
                       :Ind="leftTabInd"
                       :refeshflag="refeshflag"
                       :title="blockData.title"
                       :preTabListTop="preTabListTop"
                       :nav="nodeNavTop"
                       :flowSlideshow="blockData.flowSlideshow"
                       @changeTab="changeFlowTab">
              </top-tab>
              <!--顶部切换结束-->
              <!--主要内容开始-->
              <div v-if="!iframeSrc&&!rightSrc"
                   ref="centerEle">
                <!-- 左右多图文 -->
                <expert v-if="centerStyle=='expertsAlliance'"
                        @emitHandleDetail="handleDetail"
                        @emitContextMenuItem="leftRightMove"
                        :class="[centerStyle,'smartAppSameScreenShow']"
                        :tagsDataList="listData" />
                <!-- 多图展示 -->
                <enterpris v-else-if="centerStyle=='enterprisAlliance'"
                           @emitHandleDetail="handleDetail"
                           @emitContextMenuItem="leftRightMove"
                           :class="[centerStyle,'smartAppSameScreenShow']"
                           :tagsDataList="listData" />
                <!-- 信息列表 -->
                <news v-else-if="centerStyle=='article'"
                      @emitHandleDetail="handleDetail"
                      @emitContextMenuItem="leftRightMove"
                      :class="[centerStyle,'smartAppSameScreenShow']"
                      :tagsDataList="listData" />
                <!-- 同屏展示 -->
                <baseGroup v-else-if="centerStyle=='smartAppSameScreenShow'"
                           @emitHandleDetail="handleDetail"
                           @emitContextMenuItem="leftRightMove"
                           :centerStyle="centerStyle"
                           :preNum="preNum"
                           :swiperInd="swiperInd"
                           :standList="standardListJson" />
                <!-- 多图遮罩/标准楼层 -->
                <smartApp v-else-if="centerStyle=='smartApp'||centers == 'banner'"
                          :centerStyle='centerStyle'
                          :blockData='blockData'
                          :blockCenterList='blockCenterList'
                          :tabActiveType="tabActiveType"
                          @emitHandleDetail="handleDetail"
                          :tabLeftRightLen="tabLeftRightLen"
                          :listData="listData"
                          @emitContextMenuItem="leftRightMove"
                          ref='smartApp'
                          @emitChangeFlowTab='changeFlowTab'
                          :flowStep='flowStep'
                          :swiperInd='swiperInd' />
                <!-- 图文信息 -->
                <tradeNews v-else-if="centerStyle=='tradeNews'"
                           :centerStyle='centerStyle'
                           :blockCenterList='blockCenterList'
                           :blockData='blockData'
                           :listData="listData" />
                <!-- 多图文列表 -->
                <knowledgeCenter v-else-if="centerStyle=='knowledgeCenter'"
                                 :centerStyle='centerStyle'
                                 :blockData='blockData'
                                 @emitHandleDetail="handleDetail"
                                 @emitContextMenuItem="leftRightMove"
                                 :listData="listData"
                                 :tabLeftRightLen="tabLeftRightLen" />
                <!-- 流程架构 -->
                <baseGroupProcess v-else-if="centerStyle=='flowArchShow'"
                                  :class="['flowArchShow']"
                                  :style="{height:`${baseNavHeight-66}px`}"
                                  :centerStyle="centerStyle"
                                  :preNum="preNum"
                                  :swiperInd="swiperInd"
                                  :standList="standardListJson"
                                  @emitHandleDetail="handleDetail"
                                  @emitContextMenuItem="leftRightMove" />
                <!-- 单图文展示/企业简介 -->
                <qyjjContent v-else-if="centerStyle=='companyIntroduce'"
                             :blockData='blockData' />
                <!-- 线型图 -->
                <smartChart v-else-if="centerStyle=='smartChart'"
                            :blockData='blockData'
                            ref='_changeFlowTab' />
                <!-- 横向列表区块 -->
                <horizontal v-else-if="centerStyle=='leftRightImgText'"
                            @emitHandleDetail="handleDetail"
                            @emitContextMenuItem="leftRightMove"
                            :listData='listData' />
                <!-- 小区块 -->
                <smallBlock v-else-if="centerStyle=='pictureImgText'"
                            @emitHandleDetail="handleDetail"
                            @emitContextMenuItem="leftRightMove"
                            :listData='listData' />
              </div>
              <!-- 右键链接展示开始 -->
              <div v-if="rightSrc">
                <!--切换一开始-->
                <iframe :style="{width:'100%',height:`${height}px`}"
                        :src="rightSrc"
                        frameborder="0"></iframe>
                <!--切换一结束-->
              </div>
              <!-- 右键链接展示结束 -->
              <div v-if="iframeSrc"
                   class="bottom-switch"
                   :class="['smartApp']">
                <!--切换一开始-->
                <iframe style="width:100%;height:100%;"
                        :src="iframeSrc"
                        frameborder="0"></iframe>
                <!--切换一结束-->
              </div>
              <!--主要内容结束-->
              <bottom-tab v-if="floorTabShow&&(floorTabShow.indexOf('down')>-1)"
                          :tabActiveType="tabActiveType"
                          :Ind="leftTabInd"
                          :refeshflag="refeshflag"
                          :title="blockData.title"
                          :preTabListTop="preTabListBottom"
                          :nav="nodeNavDown"
                          :blockData="blockData"
                          @changeTab="changeFlowTab"></bottom-tab>
            </div>
            <!--右侧切换一结束-->
          </div>
          <!--右侧内容区结束-->
          <right-tab v-show="isPC?'true':showRightMenu"
                     v-if="floorTabShow&&(floorTabShow.indexOf('right')>-1)"
                     :Ind="leftTabInd"
                     :tabActiveType="tabActiveType"
                     :perNum="tabTopBottomLen"
                     :refeshflag="refeshflag"
                     :preTabListTop="preTabListRight"
                     :nav="nodeNavRight"
                     :navHeight="427"
                     :blockData="blockData"
                     @changeTab="changeFlowTab" />
        </div>
      </div>
    </div>
    <!--正常内容 结束-->
  </div>
</template>
<script>
import Bus from '../../bus.js'
import tit from "./control/tit.vue"
import topTab from "./control/topTab.vue"
import bottomTab from "./control/bottomTab.vue"
import leftTab from "./control/leftTab.vue"
import rightTab from "./control/rightTab.vue"
import expert from "./expert.vue"
import enterpris from "./enterpris.vue"
import news from "./news.vue"
import knowledgeCenter from "./knowledgeCenter.vue"
import baseGroup from "./baseGroup.vue"
import baseGroupProcess from "./baseGroupProcess.vue"
import ZImage from "../ZImage.vue"
import smartApp from "./smartApp.vue"
import tradeNews from "./tradeNews.vue"
import qyjjContent from "./qyjjContent.vue"
import smartChart from "./smartChart.vue"
import horizontal from "./horizontal_list.vue"
import smallBlock from "./small_block.vue"
export default {
  name: 'chart',
  components: {
    tit: tit,
    topTab,
    bottomTab,
    leftTab,
    rightTab,
    expert,
    enterpris,
    ZImage,
    news,
    knowledgeCenter,
    baseGroup,
    smartApp,
    tradeNews,
    qyjjContent,
    smartChart,
    horizontal,
    smallBlock,
    baseGroupProcess
  },
  props: {
    blockData: {
      type: Object
    },
    _centerStyle: {
      require: true,
      default: ""
    },
    baseNavHeight: {
      type: Number,
      default: 425
    }
  },
  data () {
    return {
      timeOutEvent: 0,
      rightSrc: '',
      height: '',
      heights: '',
      centers: '',
      iframeSrc: '',
      showLeftMenu: false,
      showRightMenu: false,
      visible: false,
      value1: 0,
      value2: 20,
      switchs: true,
      play: true,
      isCurr: false,
      tagsMenuPos: {
        left: 0,
        top: 0
      },
      tagsShow: false,
      tagsName: [],
      tagsValue: [],
      leftTabInd: 0,
      topTabInd: 0,
      listData: [],
      showList: false,
      refeshflag: false,
      preTabListTop: [],
      nodeNavTop: [],
      nodeNavLeft: [],
      nodeNavRight: [],
      nodeNavDown: [],
      blockId: '',
      flowId: '',
      nodeId: '',
      contentId: '',
      preTabList: [],
      preTabListLeft: [],
      preTabListRight: [],
      preTabListBottom: [],
      floorTabShow: '',
      preStep: 0,
      tabTopBottomLen: 0,
      tabLeftRightLen: 0,
      tabActiveType: 'up',
      preNum: 6,
      circleTabList: [],
      canAddCircleData: true,
      candliverProp: true,
      centerStyle: '',
      centerStyles: '',
      blockCenterList: '',
      swiperInd: '',
      standardListJson: []
    }
  },
  watch: {
    "$store.state.rightSrc": function (val) {
      if (!this.rightSrc) {
        this.rightSrc = this.blockData.id == window.$floorflowId ? val : '';
        this.height = this.heights;
      }
    },
    floorTabShow: function (tabShow) {
      var tableft = tabShow.indexOf('left') > -1;
      var tabright = tabShow.indexOf('right') > -1;

      var tabbottom = tabShow.indexOf('down') > -1;
      var tabtop = tabShow.indexOf('up') > -1;

      var preNum = 6;
      var Len = 0;
      var tbLen = 0;
      if (tableft || tabright) {
        Len = 1;
        preNum = 5;
        if (tableft && tabright) {
          Len = 2;
          preNum = 4;
        }
      }
      if (tabbottom || tabtop) {
        tbLen = 1;
        if (tabbottom && tabtop) {
          tbLen = 2;
        }
      }

      if (window.innerWidth <= 768) {
        tbLen = 0;
        Len = 0;
      }

      this.preNum = preNum;
      this.tabLeftRightLen = Len;
      this.tabTopBottomLen = tbLen
    },
  },
  computed: {
    isPC () {
      // if(window.innerWidth > 768){
      if (window.innerWidth) {
        return true;
      } else { return false; }
    },
    tagData () {
      return this.$store.state.tagData;
    },
  },
  mounted () {
    this.centerStyles = this._centerStyle;
    this.centerStyle = this._centerStyle;
    //添加 第一个主流程tab图释
    var { id, flowType, code, appId, name, pcode, floorType } = this.blockData;
    var Mainitem = { id, flowType, code, appId, name, pcode, floorType, tabType: 'main' }
    this.blockData.dataArr.unshift(Mainitem)
    this.getTabBlock(id)
    var _this = this;
    //监听中间块高度
    var elementResizeDetectorMaker = require("element-resize-detector")
    var erd = elementResizeDetectorMaker();
    //监听中心展示高度
    erd.listenTo(this.$refs.centerEle, function (element) {
      _this.heights = element.clientHeight;
    })
  },
  methods: {
    touchstarts () {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.handleContextmenu();
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchmove: function () {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    touchend: function (e) {
      clearTimeout(this.timeOutEvent);
      return false;
    },
    //关闭中心iframe
    clearSrc () {
      this.rightSrc = '';
    },
    //跳转个人信息页面
    changePerson (item) {
      //通过
      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getFlowByUserId.json", {
          // appId:this.blockData.appId,
          appId: this.getQuery('appId'),
          userId: item.userId,
        }).then(res => {
          if (res.state == 1) {
            this.nodeNavTop = res.data;
          }
        })
      this.iframeSrc = 'https://cms.520emv.com/acnid-project-approve/bsys/commonchooseUser/tsyscircleuser/myInfo?userId=' + item.userId;
    },
    setTagData () {
      var tableft = this.floorTabShow.indexOf('left') > -1;
      var tabright = this.floorTabShow.indexOf('right') > -1;

      var tabbottom = (this.floorTabShow.indexOf('down') > -1);
      var tabtop = (this.floorTabShow.indexOf('up') > -1);

      var preNum = 6;
      var Len = 0;
      var tbLen = 0;
      if (tableft || tabright) {
        Len = 1;
        preNum = 5;
        if (tableft && tabright) {
          Len = 2;
          preNum = 4;
        }
      }
      if (tabbottom || tabtop) {
        tbLen = 1;
        if (tabbottom && tabtop) {
          tbLen = 2;
        }
      }
      if (window.innerWidth <= 768) {
        tbLen = 0;
        Len = 0;
      }
      this.preNum = preNum;
      this.tabLeftRightLen = Len;
      this.tabTopBottomLen = tbLen;
    },
    handleContextmenu () {
      this.$store.commit('setFlowType', this.blockData.floorType);
      window.$floorflowId = this.blockData;
      window.$floorId = this.flowId;
      window.$nodeId = this.nodeId;
      window.$blockId = this.blockId;
      Bus.$emit('sendCircleType', { circle: this.canAddCircleData, dliverProp: this.candliverProp });
      if (!this.blockId || !this.nodeId) {
        this.$store.commit('setflowOrBlockType', 'flow');
      }
    },
    //获取左右上下
    getTabBlock (id) {
      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/getShowFlowPosition.json", {
          appId: this.$appId,
          flowId: id,
          flowOrDetail: 'flow',
          domainNameType: document.location.pathname.split('/')[1]
        }).then(res => {
          if (res.state == 1) {
            this.floorTabShow = res.data ? res.data : ''
          }
          this.floorTabShow = this.floorTabShow ? this.floorTabShow : 'up'

          return this.$blockGetData.getActiveType(res.data);

          // if(this.floorTabShow.indexOf('center')>-1){
          //     this.getCheckTabFlowAndBlock(id,'floor-center-prioroty');
          // }

          // if(this.floorTabShow.indexOf('up')>-1){
          //     this.getCheckTabFlowAndBlock(id,'flow-nav-prioroty');
          // }

          // if(this.floorTabShow.indexOf('left')>-1){
          //     this.getCheckTabFlowAndBlock(id,'floor-left-prioroty');
          // }

          // if(this.floorTabShow.indexOf('right')>-1){
          //     this.getCheckTabFlowAndBlock(id,'floor-right-prioroty');
          // }

          // if(this.floorTabShow.indexOf('down')>-1){
          //     this.getCheckTabFlowAndBlock(id,'floor-bottom-prioroty');
          // }


          this.setTagData();
        }).then((tablist) => {
          //根据 返回勾选进行中间块标签块请求 
          // 1. 标准楼层中间块暂时 不能进行标签请求
          // 2. 数据请求按照中间、上、左、右、下勾选顺序进行请求
          // 3. 当无数据使用空数据进行填充
          tablist.map((tab) => {
            this.getSelectTabFlowAndBlock(id, tab, tablist[0]);
          })

        })

      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/getShowFlowPosition.json", {
          appId: this.$appId,
          flowId: id,
          flowOrDetail: 'detail',
          domainNameType: document.location.pathname.split('/')[1]
        }).then(res => {
          if (res.state == 1) {
            this.floorDetailShow = res.data
          }
          this.floorDetailShow = this.floorDetailShow ? this.floorDetailShow : 'down'
        })
    },
    //通过 上下左右映射 ajax types的值
    getMapValuesByFloorTabType (floorTabShow = 'up') {
      var type = 'flow-nav-prioroty';
      switch (floorTabShow) {
        case 'up':
          type = 'flow-nav-prioroty';
          break;
        case 'left':
          type = 'floor-left-prioroty';
          break;
        case 'right':
          type = 'floor-right-prioroty';
          break;
        case 'down':
          type = 'floor-bottom-prioroty';
          break;
        default:
          type = 'flow-nav-prioroty';
      }
      return type;
    },
    getSelectTabFlowAndBlock (fId, tab, firstTab) {
      const _this = this;
      const tabtype = this.getMapValuesByFloorTabType(tab);
      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getMainTopNavList.json", {
          appId: this.$appId,
          types: tabtype,
          flowId: fId
        }).then(res => {
          if (res.state == 1) {
            _this.setTabValuesByFloorTabType(tab, res.data, firstTab);
          }
        })
    },
    //获取楼层左侧右键勾选的流程、流程块、商圈
    getLeftCircleSelectValues (item = {}) {
      const _this = this;
      return this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getFloorLeftFlowAndCircle.json", {
          // appId:this.blockData.appId,
          appId: this.getQuery('appId'),
          flowId: _this.blockData.id,
          navType: 'floor-left-prioroty',
          clickFlowId: item.id ? item.id : ''
        })
    },
    //通过上下左右 设置对应的tab勾选数据
    setTabValuesByFloorTabType (floorTabShow, list = [], first) {
      var _this = this;
      const tabItemParam = { refesh: false, activeTab: 0, tabType: first };
      switch (floorTabShow) {
        case 'up':
          // ---------
          // this.preTabListTop = list;
          // this.nodeNavTop = list;
          // ---------
          if (list.length) {
            list.forEach((ite) => {
              ite.tabType = 'check';
            })
          }
          if (this.blockData.flowSlideshow == 'on') {
            this.nodeNavTop = [...list, ...this.blockData.dataArr];
            this.preTabListTop = [...list, ...this.blockData.dataArr];
          } else {
            this.nodeNavTop = list;
            this.preTabListTop = list;
          }
          // if(first=='up'){
          //     this.changeFlowTab(this.nodeNavTop[0],tabItemParam);
          // }
          break;
        case 'left':
          var leftRes = this.getLeftCircleSelectValues();
          _this.preTabListLeft = [];
          _this.nodeNavLeft = [];
          leftRes.then(res => {
            if (res.state == 1) {
              _this.isQuote = true;
              if (res.data.childFlowArr) {
                _this.nodeNavLeft.unshift(...res.data.childFlowArr);
                _this.preTabListLeft.unshift(...res.data.childFlowArr);
              }

              if (res.data.circleArr) {
                _this.nodeNavLeft.unshift(...res.data.circleArr);
                _this.preTabListLeft.unshift(...res.data.circleArr);
              }

            } else {
              _this.preTabListLeft = list;
              _this.nodeNavLeft = list;
            }
          })
          if (first == 'left') {
            this.changeFlowTab(list[0], tabItemParam);
          }
          // if(list.length==0){
          //     this.canAddCircleData = true;
          // }
          // this.candliverProp = true;
          break;
        case 'right':
          this.preTabListRight = list;
          this.nodeNavRight = list;
          if (first == 'right') {
            this.changeFlowTab(list[0], tabItemParam);
          }
          break;
        case 'down':
          this.preTabListBottom = list;
          this.nodeNavDown = list;
          if (first == 'down') {
            this.changeFlowTab(list[0], tabItemParam);
          }
          break;
        default:
        // this.preTabList = list;
        // this.changeFlowTab(this.blockData.dataArr[0],tabItemParam);
      }

    },
    getCheckTabFlowAndBlock (fId, tabtype) {
      const _this = this;
      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getMainTopNavList.json", {
          appId: this.$appId,
          types: tabtype,
          flowId: fId
        }).then(res => {
          if (tabtype == 'flow-nav-prioroty') {
            _this.preStep = 2;
          }
          if (res.state == 1) {
            if (tabtype == 'flow-nav-prioroty') {
              //添加 优先级标识
              if (res.data) {
                res.data.forEach((ite) => {
                  ite.tabType = 'check';
                  if (ite.flowType == 'block') {
                    ite.hideTag = true;
                  }
                })
                _this.preTabList = res.data;
              }

            } else if (tabtype == 'floor-center-prioroty') {
              if (res.data) {
                _this.blockCenterList = res.data
              }
            } else if (tabtype == 'floor-left-prioroty') {
              if (res.data) {
                _this.preTabListLeft = res.data
                _this.nodeNavLeft = res.data

              }
            } else if (tabtype == 'floor-bottom-prioroty') {
              if (res.data) {
                _this.preTabListBottom = res.data
                _this.nodeNavDown = res.data
              }
            } else if (tabtype == 'floor-right-prioroty') {
              if (res.data) {
                _this.preTabListRight = res.data
                _this.nodeNavRight = res.data
              }
            }

            if (_this.floorTabShow.indexOf('center') > -1) {
              _this.changeFlowTab(_this.preTabList[0] ? _this.preTabList[0] : _this.blockData.dataArr[0], { refesh: false, activeTab: 0, tabType: 'up' });
              return;
            } else if (_this.floorTabShow.indexOf('up') > -1) {
              _this.changeFlowTab(_this.preTabList[0] ? _this.preTabList[0] : _this.blockData.dataArr[0], { refesh: false, activeTab: 0, tabType: 'up' });
              return;
            } else if (_this.floorTabShow.indexOf('left') > -1) {
              this.changeFlowTab(_this.preTabListLeft[0], { refesh: false, activeTab: 0, tabType: 'left' });
              return;
            } else if (this.floorTabShow.indexOf('right') > -1) {
              _this.changeFlowTab(_this.preTabListRight[0], { refesh: false, activeTab: 0, tabType: 'right' });
              return;
            } else if (this.floorTabShow.indexOf('down') > -1) {
              _this.changeFlowTab(_this.preTabListBottom[0], { refesh: false, activeTab: 0, tabType: 'down' });
              return;
            } else {
              _this.changeFlowTab(_this.preTabList[0] ? _this.preTabList[0] : _this.blockData.dataArr[0], { refesh: false, activeTab: 0, tabType: 'up' });
              return;
            }
          } else {
            if (_this.floorTabShow.indexOf('up') > -1) {
              _this.changeFlowTab(_this.preTabList[0] ? _this.preTabList[0] : _this.blockData.dataArr[0], { refesh: false, activeTab: 0, tabType: 'up' });
              return;
            }
          }
        })
      //楼层左侧商圈选择
      this.$blockGetData.handleCircleChoose(this.blockData.id).then(res => {
        if (res.state == "1") {
          _this.nodeNavLeft = this.$blockGetData.initGroupCircle(res.data);
          _this.preTabListLeft = this.$blockGetData.initGroupCircle(res.data);
          _this.circleTabList = res.data;
          _this.candliverProp = false;
        } else {
          _this.candliverProp = true;
        }
      });
    },
    //开关状态切换
    changeSwitch () {
      this.switchs = !this.switchs;
    },
    //播放状态切换
    changePlay () {
      this.play = !this.play;
    },
    //报警
    changeCurr () {
      this.isCurr = !this.isCurr;
    },
    //t跳转详情
    handleDetail (ite) {
      sessionStorage.setItem('floorDetailShow', this.floorDetailShow)
      this.$store.commit('setPreItem', this.nodeNavTop[0]);
      this.$blockGetData.handleDetail(this, ite);

    },
    windowRightMenu (ev) {
      window.$floorflowId = this.blockData;
      this.tagsMenuPos.left = ev.pageX;
      this.tagsMenuPos.top = ev.pageY;
      this.$emit('contmenuo', { tagsName: this.tagsName, tagsValue: this.tagsValue })
    },
    //通过流程请求下级
    getFlowOrBlockByFlowId (item, param) {
      this.flowId = item.id;
      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getFlowFloorDataSpit.json", {
          // appId:this.blockData.appId,
          appId: this.getQuery('appId'),
          flowId: item.id,
          sceneGroupId: '',
          diyPageFlowId: '',
          domainNameType: document.location.pathname.split('/')[1]
        }).then(res => {
          if (param.refesh) {
            this.centerStyle = res.data[0].floorStyle ? res.data[0].floorStyle : res.data[0].floorType;
            if (this.centerStyle == 'flowArchShow') {
              this.floorTabShow = [];
              this.$refs.rightContent.style.border = 0;
            } else {
              this.$refs.rightContent.style.border = '1px solid #ddd';
            }
          }
          if (this.centerStyle == 'banner') {
            this.centers = 'banner';
          }
          if (this.centerStyle == 'smartChart') {
            this.$refs._changeFlowTab.changeFlowTab(item, param);
          }
          if (res.state == 1) {
            this.handleTabDataAll(item, param, res.data)
          }

        })

    },
    //tab切换数据处理
    handleTabDataAll (item, param, resData) {
      const _this = this;
      if (resData && resData[0].dataArr && resData[0].dataArr.length > 0) {
        if (item.flowType == "flow") {
          _this.leftTabInd = 0;
          if (param.tabType == 'up' && param.refesh) {
            _this.nodeNavTop = resData[0].dataArr;
            _this.nodeNavTop.unshift(item);
          }
          //中间点击
          if (param.tabType == 'center' && param.refesh) {
            _this.blockCenterList = resData[0].dataArr;
            _this.blockCenterList.unshift(item);
          }
          if (param.tabType == 'left' && param.refesh) {
            // _this.nodeNavLeft = resData[0].dataArr
            // _this.nodeNavLeft.unshift(item);
            if (_this.isQuote) {
              var leftRes = _this.getLeftCircleSelectValues(item);
              leftRes.then(res => {
                if (res.state == 1) {
                  _this.isQuote = true;
                  _this.nodeNavLeft = [];
                  if (res.data.circleArr) {
                    _this.nodeNavLeft.push(...res.data.circleArr);
                  }
                  if (res.data.childFlowArr) {
                    _this.nodeNavLeft.push(...res.data.childFlowArr);
                  }
                  _this.nodeNavLeft.unshift(item);
                } else {
                  _this.nodeNavLeft = resData[0].dataArr;
                  _this.nodeNavLeft.unshift(item);
                }
              })
            } else {
              _this.nodeNavLeft = resData[0].dataArr
              _this.nodeNavLeft.unshift(item);
            }
          }
          //右侧tab点击
          if (param.tabType == 'right' && param.refesh) {
            _this.nodeNavRight = resData[0].dataArr
            _this.nodeNavRight.unshift(item);
          }
          //下侧tab点击
          if (param.tabType == 'down' && param.refesh) {
            _this.nodeNavDown = resData[0].dataArr
            _this.nodeNavDown.unshift(item);
          }
          //解决流程点击不显示默认图片问题
          // _this.handleMore(item);
        }
      } else {
        _this.setDefaultTags()
      }
    },
    //通过流程获取标签
    getTagsByFlowId (fId, pageNum = 1, param) {
      const _this = this;
      this.$http.get("/zciid-deliverable/showPlatformStyle/flow/api/getContentDataByflowId.json", {
        appId: this.$appId,
        flowId: fId,
        pageSize: 10,
        pageNum: pageNum
      }).then((res) => {
        if (res.state == 1) {
          _this.todoChartData([], param);
          _this.standardListJson.push(...res.data);
          if (res.data.length == 10) {
            _this.getTagsByFlowId(fId, pageNum + 1);
          }
        } else {
          if (pageNum == 1) {
            _this.todoChartData([], param);
          } else {
            _this.flowStep = 4
          }
        }
      })
    },
    changeFlowTab (item, param) {
      if (param.refesh) {
        this.$store.commit('setflowOrBlockType', item.flowType);
      }
      if (!item) { return false }
      this.iframeSrc = '';
      if (item.pageUrl && item.pageUrl != 'javascript:;') {
        // this.open(item.pageUrl, "_blank");
        window.location.assign(item.pageUrl)
        return false;
      }
      this.swiperInd = item.id ? item.id : '';
      // this.$store.commit('setPreItem',item);
      this.tabActiveType = param.tabType;
      const _this = this;
      if (item.flowType == "flow") {
        this.flowId = item.id;
        this.$http
          .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getFlowFloorDataSpit.json", {
            // appId:_this.blockData.appId,
            appId: _this.getQuery('appId'),
            flowId: item.id,
            sceneGroupId: '',
            diyPageFlowId: '',
            domainNameType: document.location.pathname.split('/')[1]
          }).then(res => {
            if (res.state == 1) {
              _this.listData = []
              _this.getFlowOrBlockByFlowId(item, param);
              _this.getTagsByFlowId(item.id, 1, param);
            }
          })
      } else if (item.flowType == "block") {
        this.blockId = item.id;
        this.nodeId = item.nodeId;
        this.$http
          .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getContentDataByBlockNodeId.json", {
            // appId:this.blockData.appId,
            appId: this.getQuery('appId'),
            sceneId: this.$route.query.sceneId,
            blockId: item.id,
            nodeId: item.nodeId,
            sceneGroupId: this.$route.query.sceneGroupId
          }).then(res => {
            if (res.state == 1) {
              if (res.data[0].floorStyle) {
                _this.centerStyle = res.data[0].floorStyle;
                if (res.data[0].floorStyle == 'flowArchShow') {
                  _this.floorTabShow = [];
                  this.$refs.rightContent.style.border = 0;
                } else {
                  this.$refs.rightContent.style.border = '1px solid #ddd';
                }

              } else if (param.refesh) {
                _this.centerStyle = _this.centerStyles;
                if (_this.centerStyles == 'flowArchShow') {
                  _this.floorTabShow = [];
                  this.$refs.rightContent.style.border = 0;
                } else {
                  this.$refs.rightContent.style.border = '1px solid #ddd';
                }
              };
              if (this.centerStyle == 'banner') {
                this.centers = 'banner';
              }
              if (this.centerStyle == 'smartChart') {
                this.$refs._changeFlowTab.changeFlowTab(item, param);
              }
              if (param.tabType == 'up') {
                _this.leftTabInd = 0;
              } else {
                _this.leftTabInd = param.activeTab;
              }
              this.todoChartData(res.data, param);
              var arr = [];
              if (param.refesh) {

                res.data[0].standardJson.forEach((stand) => {
                  if (stand.standardName != '图释' && stand.standardName != '单位') {
                    arr.push({ 'name': stand.standardName });
                  }
                })
                if (!item.hideTag) {
                  _this.nodeNavTop = arr;
                } else {
                  _this.nodeNavTop = []
                }
                _this.nodeNavTop.unshift(item);

              }

            }
          })
      } else if (item.flowType == "circle") {
        let filterList = this.circleTabList.filter((ele) => ele.types == item.types);
        _this.nodeNavLeft = filterList;
        _this.preTabListLeft = filterList;
      }
    },
    //刷新数据
    refeshData () {
      this.leftTabInd = 0;
      this.tabActiveType = "top"
      this.refeshflag = !this.refeshflag;
      this.blockData.dataArr = this.preTabListTop;
      var Mainitem = this.preTabListTop[0];
      this.nodeNavTop = this.preTabListTop;
      this.changeFlowTab(Mainitem, { refesh: false, activeTab: 0, tabType: 'up' });
      this.rightSrc = ''
    },
    todoChartData (charArray, param) {
      const _self = this;
      var charArr = charArray.length ? charArray : [
        {
          "sceneGroupId": "",
          "contentId": "zciid-jfwgl001000000000000guru1599891131419105350",
          "sceneId": "iaiid-a018iaiid0011599886259762221459",
          "standardJson": [
            {
              "sceneGroupId": "",
              "standardName": "图释",
              "standardData": "A",
              "sceneId": "iaiid-a018iaiid0011599886259762221459",
              "standardId": "zciid-jfwgl001000000000000guru1599885370619926427",
              "standardType": "0",
              "isPriority": "0",
              "isShow": "0",
              "flowType": "standard"
            },
            {
              "sceneGroupId": "",
              "standardName": "周一",
              "standardData": "20",
              "sceneId": "iaiid-a018iaiid0011599886259762221459",
              "standardId": "zciid-jfwgl001000000000000guru1599885370619926427",
              "standardType": "0",
              "isPriority": "0",
              "isShow": "0",
              "flowType": "standard"
            },
            {
              "sceneGroupId": "",
              "standardName": "周二",
              "standardData": "30",
              "sceneId": "iaiid-a018iaiid0011599886259762221459",
              "standardId": "zciid-jfwgl001000000000000guru1599885389090912067",
              "standardType": "0",
              "isPriority": "0",
              "isShow": "0",
              "flowType": "standard"
            },
            {
              "sceneGroupId": "",
              "standardName": "周三",
              "standardData": "40",
              "sceneId": "iaiid-a018iaiid0011599886259762221459",
              "standardId": "zciid-jfwgl001000000000000guru1599885389090912067",
              "standardType": "0",
              "isPriority": "0",
              "isShow": "0",
              "flowType": "standard"
            },
            {
              "sceneGroupId": "",
              "standardName": "周四",
              "standardData": "50",
              "sceneId": "iaiid-a018iaiid0011599886259762221459",
              "standardId": "zciid-jfwgl001000000000000guru1599885389090912067",
              "standardType": "0",
              "isPriority": "0",
              "isShow": "0",
              "flowType": "standard"
            },
            {
              "sceneGroupId": "",
              "standardName": "单位",
              "standardData": "℃",
              "sceneId": "iaiid-a018iaiid0011599886259762221459",
              "standardId": "zciid-jfwgl001000000000000guru1599885389090912067",
              "standardType": "0",
              "isPriority": "0",
              "isShow": "0",
              "flowType": "standard"
            }
          ]
        }
      ];
      //1.1 如果没有数据 反回空
      if (charArr.length > 0) {
        //1.2 有数据 进行处理
        //1.2.1 取出 x轴 list xAxios  y轴 list series 
        var xAxios = [], series = [], legend = [], yName;
        charArr.forEach((chart, cind) => {
          var item = {
            name: '',
            smooth: true,
            type: 'line',
            data: []
          };
          var standLen = chart.standardJson.length;
          if (standLen > 0) {
            var lineData = [];
            chart.standardJson.forEach((stand) => {
              if (stand.standardName == '图释') {
                legend.push(stand.standardData)
                item.name = stand.standardData;
              } else if (stand.standardName == '单位') {
                yName = stand.standardData;
              } else {
                if (cind == 0) {
                  xAxios.push(stand.standardName);
                  // alert(stand.standardName)
                  if (param.tabType == 'up') {
                    if (!param.refesh) {
                      _self.nodeNavTop.push(stand.standardName);
                    }
                  }
                }
                lineData.push(stand.standardData ? stand.standardData : Math.round(Math.random() * 100))
              }

            })
            item.data = lineData;
            series.push(item);
          }
        })
        var option = {
          color: ['#d14a61', '#3398DB'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          toolbox: {
            feature: {
              magicType: {
                type: ['line', 'bar']
              }
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          legend: {
            data: legend
          },
          xAxis: [
            {
              type: 'category',
              data: xAxios,
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              name: yName,
              type: 'value'
            }
          ],
          series: series
        }
        var _this = this;
        setTimeout(function () {
          _this.initEchart(option);
        }, 1000);

      }
    },
    initEchart (option) {
      // var myChart  = window.echarts.init(this.$refs.echart);
      // myChart.setOption(option);
    }
  }
}
</script>
<style>
.el-slider__button-wrapper {
  z-index: 0;
}
</style>
<style scoped>
/*58智能产品的区块css*/

.right-content {
  border: 1px solid #ddd;
}
.bottom-switch {
  padding: 18px 20px;
  height: 328px;
  overflow: hidden;
  position: relative;
}
.bottom-content {
  height: 100%;
  width: calc(100% - 120px);
  float: left;
  overflow: hidden auto;
}
.bottom-switch .operation {
  width: 120px;
  background: #ffffff;
  position: absolute;
  right: 0px;
  top: 0px;
  padding: 20px 20px 20px 0;
}
.bottom-switch .operation li {
  height: 34px;
  margin-bottom: 16px;
}

.bottom-switch .operation .switch {
  width: 32px;
  height: 32px;
  border: 1px solid #dddddd;
  border-radius: 16px;
  background-color: #fafafa;
  text-align: center;
  line-height: 30px;
  font-size: 0;
  cursor: pointer;
  margin: 0 auto;
}
.bottom-switch .operation .switch img {
  vertical-align: middle;
}

.bottom-switch .operation .suspend {
  height: 32px;
  border: 1px solid #ddd;
  border-radius: 18px;
  background-color: #fafafa;
  text-align: center;
  cursor: pointer;
}

.bottom-switch .operation .btn-ordinary {
  text-align: center;
  height: 32px;
  border: 1px solid #ddd;
  border: 1px solid #ddd;
  border-radius: 18px;
  background-color: #fafafa;
  line-height: 32px;
  font-size: 0;
  cursor: pointer;
}
.bottom-switch .operation .btn-ordinary span {
  display: inline-block;
  padding-left: 20px;
  font-size: 14px;
}
.bottom-switch .operation .btn-ordinary span.police {
  background: url(~@/assets/image/images/icons/icon_police.png) no-repeat left
    center;
}
.bottom-switch .operation .btn-ordinary span.police.curr {
  background: url(~@/assets/image/images/icons/icon_police_red.png) no-repeat
    left center;
}
.bottom-switch .operation .btn-ordinary span.adjustment {
  background: url(~@/assets/image/images/icons/icon_adjustment.png) no-repeat
    left 1px center;
}
.bottom-switch .operation .progress .strip {
  width: 94px;
  height: 34px;
  margin-left: 8px;
}

.bottom-switch .operation .progress .icon-box {
  margin-top: 7px;
}
.bottom-switch .operation .progress .icon-box .icon {
  width: 18px;
  height: 18px;
}
.block .el-slider__button {
  width: 9px;
  height: 9px;
}

/* @media screen and (min-width:426px) and (max-width: 768px) {
    .content-left-box,.content-right-box{width: 150px;position:absolute;top:0px;bottom:0px;z-index:9;background:#fff;border-left: 1px solid #dddddd;border-right: 1px solid #dddddd;height:auto;}
    .content-left-box{left:0;}
    .content-right-box{right:-1px;}
    .block-content{position: relative;}
    .btn-left,.btn-right{position: absolute;top:160px; width:30px;height:30px; border-radius:20px;z-index:8;background-size: contain;}
    .btn-left{left:2px;background-image: url("~@/assets/image/images/icons/arrow_right_circular.png");  }
    .btn-right{right:2px; background-image: url("~@/assets/image/images/icons/arrow_left_circular.png");}
    .close-left,.close-right{position: absolute;top:10px; width:20px;height:20px; border-radius:10px;z-index:10;background-size: contain;background-image: url("~@/assets/image/images/icons/close_right_top.png")}
    .close-left{left:120px;}
    .close-right{right:120px;}
} */
</style>


// WEBPACK FOOTER //
// src/components/floorBlock/chart.vue